import React from 'react'
import styles from './removeModal.module.scss'
import style from '../Modal/modal.module.scss'

const RemoveModal = ({closeModal, openModal}) => (
   <div className={styles.remove}>
      <div className={styles.remove__block}>
         <p className={styles.remove__title}>Remove done!</p>
         <span className={styles.remove__subtitle}>You have deleted all websitess</span>
         <svg onClick={closeModal} className={style.modal__cross} width='12' height='12' viewBox='0 0 12 12' fill='none'
              xmlns='http://www.w3.org/2000/svg'>
            <path opacity='0.5'
                  d='M0.409605 0.41107C0.735042 0.0856329 1.26268 0.0856329 1.58812 0.41107L5.99886 4.82181L10.4096 0.41107C10.735 0.0856329 11.2627 0.0856329 11.5881 0.41107C11.9136 0.736507 11.9136 1.26414 11.5881 1.58958L7.17737 6.00033L11.5881 10.4111C11.9136 10.7365 11.9136 11.2641 11.5881 11.5896C11.2627 11.915 10.735 11.915 10.4096 11.5896L5.99886 7.17884L1.58812 11.5896C1.26268 11.915 0.735042 11.915 0.409605 11.5896C0.0841681 11.2641 0.0841681 10.7365 0.409605 10.4111L4.82035 6.00033L0.409605 1.58958C0.0841681 1.26414 0.0841681 0.736507 0.409605 0.41107Z'
                  fill='#3F454D' />
         </svg>
         <button onClick={openModal} className={styles.remove__btn}>+Add websites</button>
      </div>
   </div>
)
export default RemoveModal